import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';

import { setModoTela, initForm } from './pontoMapaActions';

class PontoMapaForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo'
								cols='12 12 12 12'
								placeholder='Selecionea tipo'
								readOnly={readOnly} />
								
							<Field
								name='latitude'
								component={LabelAndInput}
								label='Latitude' placeholder='Informe a latitude'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Field
								name='longitude'
								component={LabelAndInput}
								label='Longitude' placeholder='Informe a longitude'
								cols='12 6 4 3'
								readOnly={readOnly} />
							
							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe a observação'
								cols='12 12 12 12'
								readOnly={readOnly} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							{!this.props.origemMapa &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>}
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

PontoMapaForm = reduxForm({form: 'pontoMapaForm', destroyOnUnmount: false})(PontoMapaForm);
const mapStateToProps = state => ({
	sessao: state.auth.pontoMapa,
	formularioValues: getFormValues('pontoMapaForm')(state),
	registro: state.pontoMapa.registro,
	listaTipo: state.pontoMapa.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PontoMapaForm);
